import {ordersService} from 'services';

export const SET_CURRENT_ORDER = 'SET_CURRENT_ORDER';
export const SET_CURRENT_ORDER_ID = 'SET_CURRENT_ORDER_ID';

const ordersStore = {
  namespaced: true,
  state () {
    return {
      currentOrder: null
    };
  },
  getters: {
    currentOrder: state => state.currentOrder
  },
  mutations: {
    [SET_CURRENT_ORDER] (state, order) {
      state.currentOrder = order;
    }
  },
  actions: {
    async [SET_CURRENT_ORDER_ID] (context, orderId) {
      if (!orderId){
        context.commit(SET_CURRENT_ORDER, null);
        return;
      }
      const order = await ordersService.get(context.rootGetters['accounts/currentAccountId'], orderId);
      context.commit(SET_CURRENT_ORDER, order);
    }
  }
};

export default ordersStore;
